import type { Messages } from '../catalogue.en'

/**
 * The personal notification inbox behind the header bell.
 *
 * The unread count reads `Непрочитанных уведомлений: {count}`. Only the
 * exact-one string may put a Russian noun in a number's company; see the note
 * in `ru/common.ts`.
 *
 * Composed into the public catalogue by `catalogue.ru.ts`. Nothing imports
 * this module directly: consumers ask the catalogue, so how the messages are
 * stored stays this layer's business.
 */
export const notifications: Partial<Messages> = {
  'notifications.trigger': 'Уведомления',
  'notifications.triggerUnreadOne': '1 непрочитанное уведомление',
  'notifications.triggerUnreadMany': 'Непрочитанных уведомлений: {count}',
  'notifications.title': 'Уведомления',
  'notifications.markAllRead': 'Отметить все как прочитанные',
  'notifications.loading': 'Загрузка уведомлений',
  'notifications.loadFailed': 'Не удалось загрузить уведомления.',
  'notifications.empty': 'Новых уведомлений нет',
  'notifications.emptyDetail': 'Здесь появляются напоминания о задачах, отправленные вам в приложении.',
  'notifications.unread': 'Не прочитано',
  'notifications.newestShown': 'Показаны последние {count}',
  'notifications.markReadFailed': 'Не удалось отметить уведомление прочитанным.',
  'notifications.markAllFailed': 'Не удалось отметить уведомления прочитанными.',
  'notifications.actionForbidden': 'Эта учётная запись не может отмечать уведомления прочитанными.',
  'notifications.actionUnavailable': 'Уведомления недоступны. Повторите чуть позже.',
  'notifications.rowGone': 'Этого уведомления больше нет в вашем списке.',
}
